import { useLocale } from "../../../context/LanguageContext";
import type { LeadStats } from "../types";

interface LeadStatsBarProps {
  stats: LeadStats | undefined;
  loading: boolean;
}

export function LeadStatsBar({ stats, loading }: LeadStatsBarProps) {
  const { t } = useLocale();

  const cards = [
    {
      label: t("leads.stats.total"),
      value: stats?.totalLeads ?? 0,
      emoji: "📊",
    },
    {
      label: t("leads.stats.newThisWeek"),
      value: stats?.newLeadsThisWeek ?? 0,
      emoji: "🆕",
    },
    {
      label: t("leads.stats.conversionRate"),
      value: `${stats?.conversionRate?.toFixed(1) ?? "0.0"}%`,
      emoji: "🎯",
    },
    {
      label: t("leads.stats.avgDaysToClose"),
      value: stats?.avgDaysToClose ?? 0,
      emoji: "⏱️",
    },
  ];

  if (loading && !stats) {
    return (
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="h-20 animate-pulse rounded-lg border border-border bg-card"
          />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      {cards.map((card) => (
        <div
          key={card.label}
          className="rounded-lg border border-border bg-card px-4 py-3"
        >
          <div className="flex items-center gap-2">
            <span className="text-lg">{card.emoji}</span>
            <p className="text-xs font-medium text-muted-foreground">
              {card.label}
            </p>
          </div>
          <p className="mt-1 text-xl font-bold text-foreground">
            {card.value}
          </p>
        </div>
      ))}
    </div>
  );
}
